import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONSTANSTS } from '@core/constants';
import { StorageService } from '@core/services/storage.service';
import { UserInfoModel, UserModel, UserPrefrencesModel } from '@shared/models/users.model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UsersService {
  public userSubject: BehaviorSubject<UserModel>; // daha sonra private olarak değiştirilecketir.

  constructor(private storageService: StorageService, private http: HttpClient) {
    this.userSubject = new BehaviorSubject<UserModel>(JSON.parse(this.storageService.get('user')));
  }

  // get user value
  public get userValue(): UserModel {
    return this.userSubject.value;
  }

  /**
   * user info
   */
  getUserInfo(): Observable<UserInfoModel> {
    return this.http.get<UserInfoModel>(CONSTANSTS.api.users.getUserInfo);
  }

  /**
   * user avatar
   */
  get userAvatar(): Observable<string> {
    const avatar = { blobType: 'user', id: this.userValue.Email };
    return this.http.get<string>(CONSTANSTS.api.default.avatar, { params: avatar });
  }

  /**
   * Kullanıcı tercihlerini set ediyoruz.
   * @param param
   */
  setUserPreferences(param?: any): Observable<UserPrefrencesModel> {
    return this.http.get<UserPrefrencesModel>(CONSTANSTS.api.default.userPrefCheck, { params: param });
  }

  /**
   * Kullanıcı tercihlerini çekiyoruz.
   * @param param
   */
  getUserPreferences(param?: any): Observable<UserPrefrencesModel> {
    return this.http.get<UserPrefrencesModel>(CONSTANSTS.api.default.userPreferences, { params: param });
  }

}
